import React from 'react';
import interactiveImg from '../../../Assets/Image/svg/interactive.svg';
import { BtnPrimary } from '../../share/buttons/Btn';
import { HashLink } from 'react-router-hash-link';

function InteractiveBootCamp() {
	return (
		<div className='home__interactive container mb-40	mt-16'>
			<div className='home__interactive--content flex  items-center mb-12 '>
				<img src={interactiveImg} alt={interactiveImg} />

				<div className='mr-[2.6rem]'>
					<h2 className='text-md text-primary-dark mb-9 font-bold	'>
						بوت کمپ‌های تعاملی با بوت‌وب
					</h2>
					<p className='text-cd black-prim leading-extra-loose'>
						در گذشته امکان مشاهده یک سمینار به‌ صورت اینترنتی، توسط
						بسترهای پخش زنده فراهم شده بود که ارسال اطلاعات در این حالت
						به‌صورت یک‌طرفه و با یک وقفه زمانی صورت می‌گرفت. اما امروزه با
						پیدایش بسترهای جدید ارتباط آنلاین، علاوه بر ارتباط بین بیش از
						۲ نقطه، ارسال و دریافت اطلاعات به‌صورت دوطرفه و بدون وقفه نیز
						فراهم شده است که به‌ شکل قابل‌توجهی نحوه برگزاری بوت‌کمپ‌ها را
						بهبود می‌دهد.
					</p>
				</div>
			</div>
			<div className=' justify-center flex items-center'>
				<HashLink key='price' to='/price#top'>
					<BtnPrimary
						className='min-w-[40rem] py-6'
						text='همین حالا بوت‌کمپ خود را بسازید'
						type='button'
					/>
				</HashLink>
			</div>
		</div>
	);
}

export default InteractiveBootCamp;
